// extracted by mini-css-extract-plugin
export default {"container":"ndQQU3","title":"hXlnwZ","post":"jnfay8","postLink":"Ihik0w"};